import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoBox',
  props: {
    small: { type: Boolean },
    error: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid grid-cols-[24px,1fr] rounded-lg", {
			'bg-gray-20 p-4': !_ctx.small,
			'text-gray-70': _ctx.small && !_ctx.error,
			'text-error': _ctx.error,
		}])
  }, [
    _createVNode(SvgIcon, {
      class: "mr-1 text-lg",
      "icon-name": "info"
    }),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})